<template>
  <div class="attribute">
    <div class="attr-label"><p>{{ label }}</p></div>
    <div class="attr-items">
      <div class="item" @click="selectStorage(storage)" :class="{ 'active': (modelValue && modelValue.capacite === storage.capacite && modelValue.unit === storage.unit) }" v-for="(storage, index) in storages" :key="index">
        <div class="inner">
          {{ storage.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Storage',
  props: {
    store: [String, Number],
    modelValue: Object,
    label: String
  },
  computed: {
    ...mapState({
      selectedCode: state => state.stores.selected,
      stores: state => state.stores.items,
      phone: state => state.phone.item,
      loading: state => state.phone.loading
    }),
    storages () {
      const storages = []

      this.phone.storages.forEach((storage) => {
        storages.push({
          name: storage.capacite + ' ' + storage.unit.toLowerCase(),
          capacite: storage.capacite,
          unit: storage.unit
        })
      })

      return storages
    },
    selectedStore () {
      let selectedStore = null

      this.stores.forEach((store) => {
        if(store.code === this.selectedCode) {
          selectedStore = store
        }
      })

      return selectedStore
    }
  },
  methods: {
    selectStorage (storage) {
      this.$emit('update:modelValue', storage)
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.attribute{
  margin-bottom: 15px;

  &.without-margin{
    margin-bottom: 0;
  }

  .attr-label {
    margin-bottom: 15px;

    p {
      font-size: px2rem(15px);
      line-height: px2rem(22px);
      font-weight: $fontRegular;
    }
  }

  .attr-items{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    margin: 0 0 10px 0;

    @include responsive(mobile){
      display: block;
    }

    .item{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin: 0;
      padding: 20px;
      font-weight: $fontSemiBold;
      text-align: center;
      height: 50px;
      line-height: 28px;
      border: 1px solid darken($white, 10%);
      position: relative;
      cursor: pointer;
      text-transform: capitalize;
      @include radius(5px);
      @include transition();

      @include responsive(mobile){
        width: auto;
        margin-right: 10px;
        margin-bottom: 10px;
      }

      .inner {
        width: auto;
      }

      &:after {
        display: inline-block;
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        border: 2px solid $black;
        opacity: 0;
        @include radius(5px);
        @include transition();
      }

      &:hover {
        &:after {
          opacity: 1;
        }
      }

      &.active {
        color: $primary;

        &:after {
          opacity: 1;
          border: 2px solid $primary;
        }
      }
    }
  }
}
</style>
